import {
  type ReactElement,
  type PropsWithChildren,
  useRef,
  useEffect,
} from 'react';

import Parallax from 'parallax-js';
import { v4 as uuidv4 } from 'uuid';

const data = [
  'decomposition-tree',
  'waterfall-chart',
  'combo-chart',
  'circular-gauge',
  'stacked-waterfall-chart',
  'sunburst-chart',
  'error-chart',
  'bullseye',
  'gantt-chart',
  'resource-chart',
  'timeline-chart',
  'area-chart',
  'bar-chart',
  'column-chart',
  'dot-slash-marker-chart',
  'jump-line-chart',
  'line-chart',
  'pareto-chart',
  'range-area-chart',
  'range-bar-chart',
  'range-column-chart',
  'range-spline-area-chart',
  'range-step-line-area-chart',
  'rounded-column-chart',
  'spline-chart',
  'spline-area-chart',
  'stacked-area-chart',
  'percent-stacked-area-chart',
  'stacked-bar-chart',
  'percent-stacked-bar-chart',
  'stacked-column-chart',
  'percent-stacked-column-chart',
  'stacked-spline-area-chart',
  'percent-stacked-spline-area-chart',
  'stacked-step-area-chart',
  'percent-stacked-step-area-chart',
  'step-line-area-chart',
  'step-line-chart',
  'vertical-chart',
];

export default function ParallaxBackground({ children }: PropsWithChildren): ReactElement {
  const scene = useRef<HTMLDivElement | null>(null);
  const parallaxInstance = useRef<Parallax | null>(null);
  const layers = [];
  const totalLayers = Math.round(data.length / 6);
  for (let i = 0; i < totalLayers; i += 1) {
    layers.push(data.slice(i * 6, (i + 1) * 6));
  }

  useEffect(() => {
    if (scene.current) {
      parallaxInstance.current = new Parallax(scene.current, {
        relativeInput: true,
        inputElement: scene.current.parentElement,
      });

      parallaxInstance.current.enable();
    }

    return () => {
      parallaxInstance.current?.disable();
    };
  }, []);

  return (
    <div className="parallax-bg" style={{ minHeight: 'calc(100vh - 193px)' }}>
      <div className="parallax-bg__bg">
        <div className="parallax-bg__bg-scene" ref={scene}>
          {layers.map((chartTypes, i) => (
            <div key={uuidv4()} className={`parallax-bg__bg-layer parallax-bg__bg-layer--${i + 1}`} data-depth={(i + 1) / 10}>
              {chartTypes.map((chartType, j) => (
                <div key={chartType} className={`parallax-bg__bg-layer-chart chart--${j + 1}`}>
                  <div className={`svg-${chartType}`} />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="parallax-bg__content">
        {children}
      </div>
    </div>
  );
}
